import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http'
import { AuthService } from './authentication/auth.service';
import { PageService } from './utils/page.service';
import { PageDialogService } from './utils/page-dialog.service';
import { OrderByService } from './utils/order-by.service';
import { RestDeviceService } from './rest/device/rest-device.service';
import { RestPlantService } from './rest/plant/rest-plant.service';
import { RestUtilsService } from './rest/utils/rest-utils.service';
import { LastSearchedService } from './utils/last-searched.service';
import { RestUserService } from './rest/user/rest-user.service';

import { MatSnackBarModule } from '@angular/material/snack-bar';
import { GalleryService } from './utils/gallery.service';
import { PageBackofficeService } from './utils/page-backoffice.service';
import { RestSerialService } from './rest/serial/rest-serial.service';
import { DocumentationService } from './utils/documentation.service';
import { RestProcedureService } from './rest/procedure/rest-procedure.service';
import { RestArFilesService } from './rest/ar-files/rest-ar-files.service';
import { RestMaintenanceService } from './rest/maintenance/rest-maintenance.service';
import { RestMaintenanceHistoryService } from './rest/maintenance-history/rest-maintenance-history.service';
import { RestArticleCodeService } from './rest/article-code/rest-article-code.service';
import { RestDeviceDocumentationService } from './rest/device-documentation/rest-device-documentation.service';
import { RestAgendaService } from './rest/agenda/rest-agenda.service';
import { AgendaDialogService } from './utils/agenda-dialog.service';
import { CalendarService } from './utils/calendar.service';
import { CustomDateService } from './utils/custom-date.service';
import { BackofficeGalleryService } from './utils/backoffice-gallery.service';
import { BackofficeSortService } from './utils/backoffice-sort.service';
import { RestProductFamiliesService } from './rest/product-families/rest-product-families.service';
import { RestDeviceTypesService } from './rest/device-type/rest-device-types.service';


@NgModule({
  providers: [RestDeviceService,
    RestPlantService,
    RestUserService,
    RestUtilsService,
    RestSerialService,
    RestProcedureService,
    RestArFilesService,
    RestMaintenanceService,
    RestMaintenanceHistoryService,
    RestArticleCodeService,
    RestDeviceDocumentationService,
    RestAgendaService,
    RestProductFamiliesService,
    RestDeviceTypesService,
    AuthService,
    PageService,
    PageBackofficeService,
    PageDialogService,
    OrderByService,
    LastSearchedService,
    GalleryService,
    DocumentationService,
    AgendaDialogService,
    CalendarService,
    CustomDateService,
    BackofficeGalleryService,
    BackofficeSortService
  ],
  declarations: [],
  imports: [
    CommonModule,
    HttpClientModule,
    MatSnackBarModule
  ]
})
export class ServiceModule { }
